export const getUserDepartmentNames = () => {
    try {
        const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        // Support both camelCase and snake_case from API
        if (currentUser.departmentNames && currentUser.departmentNames.length > 0) {
            return currentUser.departmentNames;
        }
        if (currentUser.department_names && currentUser.department_names.length > 0) {
            return currentUser.department_names;
        }
        // Legacy support for old department string
        if (currentUser.department) {
            return currentUser.department.split(',').map(d => d.trim()).filter(Boolean);
        }
        // Default fallback
        return ['sweets'];
    } catch {
        return ['sweets'];
    }
};

export const getDefaultDepartment = () => {
    const departments = getUserDepartmentNames();
    return departments[0] || 'sweets';
};

export const userHasDepartment = (departmentName) => {
    return getUserDepartmentNames().includes(departmentName);
};

/** Japanese labels for known department slugs (align with UserSettings / business offices). */
export const DEPARTMENT_LABEL_JA = {
    sweets: '洋菓子事業部',
    snacks: '菓子事業部'
};

export const departmentLabelJa = (slug) => DEPARTMENT_LABEL_JA[slug] || slug;

/**
 * If the current path encodes a department the user is not assigned to, returns
 * { redirectTo, attemptedDepartment }. Otherwise null.
 */
export const getUnauthorizedDepartmentRedirect = (pathname) => {
    if (!pathname || typeof pathname !== 'string') {
        return null;
    }
    const path = pathname.split('?')[0].replace(/\/+$/, '') || '/';
    const defaultDept = getDefaultDepartment();

    const tryRedirect = (attemptedDept, redirectTo) => {
        if (!attemptedDept || userHasDepartment(attemptedDept)) {
            return null;
        }
        return { redirectTo, attemptedDepartment: attemptedDept };
    };

    let m = path.match(/^\/itemList\/([^/]+)$/);
    if (m) {
        return tryRedirect(m[1], `/itemList/${defaultDept}`);
    }
    m = path.match(/^\/addMenu\/([^/]+)$/);
    if (m) {
        return tryRedirect(m[1], `/addMenu/${defaultDept}`);
    }
    m = path.match(/^\/campaigns\/([^/]+)$/);
    if (m) {
        return tryRedirect(m[1], `/campaigns/${defaultDept}`);
    }
    m = path.match(/^\/estimations\/([^/]+)(?:\/([^/]+))?$/);
    if (m) {
        return tryRedirect(m[1], `/estimations/${defaultDept}`);
    }
    m = path.match(/^\/itemDetails\/([^/]+)\/([^/]+)$/);
    if (m) {
        return tryRedirect(m[1], `/estimations/${defaultDept}`);
    }
    return null;
};

